import { useEffect, useRef } from "react";

import type { CreateLabData } from "../../services/labService";
import type { OrganisationDetailsResponse } from "../../services/organisationService";
import type { LabType } from "../../types/lab";
import { CreateLabForm } from "../CreateLabForm";

interface AdminCreateLabModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateLabData) => Promise<void>;
  isLoading: boolean;
  organisation: OrganisationDetailsResponse;
  availableLabTypes: LabType[];
}

export const AdminCreateLabModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  organisation,
  availableLabTypes,
}: AdminCreateLabModalProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }

    if (isOpen && !dialog.open) {
      dialog.showModal();
    }

    if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  return (
    <dialog ref={dialogRef} className="modal" onClose={onClose}>
      <div className="modal-box max-w-3xl">
        <div className="mb-4">
          <h2 className="text-xl font-semibold">Create Lab</h2>
          <p className="mt-1 text-sm text-base-content/70">
            Add a new lab for your organisation without leaving this page.
          </p>
        </div>

        <CreateLabForm
          onSubmit={onSubmit}
          onCancel={onClose}
          isLoading={isLoading}
          organisation={organisation}
          availableLabTypes={availableLabTypes}
          renderInCard={false}
        />
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onClose}>close</button>
      </form>
    </dialog>
  );
};